import { Alert, AlertColor, Snackbar } from "@mui/material";
import { useState } from "react";
import { nanoid } from "nanoid";

/**
 * Component to show toast messages. The ToastManager should be rendered once in app.js
 *
 * How to use:
 *  import {showToast} from '@/features/shared/components/toasts'
 *
 *    showToast("Impact imminent", {type: 'error'} )
 */

type Options = {
  type?: AlertColor;
};

export const showToast = (message: string, options?: Options) => {
  if (!showToastExternal) console.error("Toasts component not rendered");
  else showToastExternal(message, options);
};

let showToastExternal: (message: string, options?: Options) => void | undefined;

export const ToastManager = () => {
  const [toast, setToast] = useState<
    { message: string; type?: AlertColor; key: string; visible: boolean } | undefined
  >();

  const showToast = (message: string, options?: Options) =>
    setToast({
      ...options,
      message,
      visible: true,
      key: nanoid(),
    });

  showToastExternal = showToast;

  const handleClose = () => {
    if (toast) setToast({ ...toast, visible: false });
  };

  return (
    <Snackbar
      open={toast?.visible}
      key={toast?.key}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={toast?.type || "success"}>
        {toast?.message}
      </Alert>
    </Snackbar>
  );
};
